<template>
  <div class="scanControll">
    <div v-if="info" class="scan" ref="scan">
      <div class="number">
        <!--        企业信用档案编号：-->
        编号：
        <div class="serial">{{ info.cert_code }}</div>
      </div>
      <div class="certName certName1">云南省建设工程材料及设备信息</div>
      <div class="certName certName2">登记卡</div>
      <div class="certCont">
        <div class="title title1">单位名称：{{ info.company_name }}</div>
        <div class="title title2">
          统一社会信用代码：
          <div class="time">{{ info.social_code }}</div>
        </div>
        <div class="title title3">地址：{{ info.register_address }}</div>
        <div class="title title4">适用范围：{{ info.scopeuse }}</div>
        <!--        <div class="title title5">登记依据：{{ info.basis }}</div>-->
        <div class="tipc">产品名称及规格型号见附录</div>
      </div>
      <img :src="'data:image/jpg;base64,' + info.cert_link" class="ma" />
      <!--      <div class="public company">云南省住房和城乡建设厅</div>-->
      <div class="public company">
        有效期： 二年
      </div>
      <div class="public company2">
        登记日期：{{ info.cert_time }}
      </div>
      <div class="linkControll">
        <div class="public link" style="letter-spacing: 1px">
          本登记卡只能在产品质量标准范围内使用，详细信息可在云南省建设工程材料及设备信息登记系统（http://cldj.ynbzde.com）中查询
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.scanControll {
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 100% 100%;

  .scan {
    height: 100vh;
    width: 100vw;
    margin: auto;
    position: relative;

    .number {
      font-size: 33px;
      font-family: "方正黑体_GBK";
      position: absolute;
      top: 12.5%;
      cmyk: 0.85, 0.56, 0.04, 0 !important;
      //jisuan
      //right: 4.83%;
      right: 13.53%;
      display: flex;
      color: #1e66ae;
      align-items: center;
      letter-spacing: 3px;
    }

    .certName {
      font-size: 62px;
      position: absolute;
      width: 100%;
      text-align: center;
      color: #1e66ae;
      //cmyk: 0.85 0.56 0.04 0;
      cmyk: 0.85, 0.56, 0.04, 0;
    }

    .certName {
      font-family: "FZCSJW";
      letter-spacing: 14px;
    }

    .certName1 {
      top: 19.69%;
    }

    .certName2 {
      top: 29%;
      letter-spacing: 40px;
      padding-left: 28px;
    }

    //.certControll {
    //  display: flex;
    //  justify-content: center;
    //  position: absolute;
    //  top: 40.34%;
    .certCont {
      .title {
        font-size: 24px;
        position: absolute;
        color: #231815;
        //jisuan
        //left: 17.59%;
        left: 10.3%;
        //font-family: "GBK";
        //font-weight: bold;
        letter-spacing: 2px;
        cmyk: 0, 0, 0, 1 !important;
      }

      .tipc {
        top: 60%;
        left: 10.3%;
        font-size: 24px;
        position: absolute;
        color: #231815;
      }

      .title1 {
        top: 38%;
      }

      .title2 {
        top: 42.5%;
        display: flex;
        align-items: center;
      }

      .title3 {
        top: 47.34%;
      }

      .title4 {
        top: 52.5%;
      }

      .title5 {
        top: 57.5%;
      }
    }

    //}
    .ma {
      //width: 15.17%;
      height: 15.17%;
      position: absolute;
      top: 65.59%;
      //jisuan
      //left: 14.9%;
      left: 10.2%;
    }

    .public {
      font-size: 24px;
      //font-weight: bold;
      position: absolute;
      color: #231815;
      letter-spacing: 2px;
      cmyk: 0, 0, 0, 1 !important;
    }

    .company {
      top: 72%;
      //jisuan
      //right: 20.07%;
      //right: 23.3%;
      right: 24.1%;
    }

    .company2 {
      top: 76%;
      //jisuan
      //right: 20.07%;
      right: 17.07%;
    }

    .date {
      top: 77.69%;
      //jisuan
      //right: 20.07%;
      right: 18%;
      display: flex;
      align-items: center;
    }

    .time {
      color: #231815;
      font-family: "SourceSansVariable-Roman-subset";
      letter-spacing: 3px;
    }

    .linkControll {
      display: flex;
      justify-content: center;

      .link {
        top: 83.9%;
        text-align: center;
        //font-weight: bold!important;
      }
    }
  }
}

@page {
  size: 45cm 29.5cm;
  padding: 0px;
  margin: 0px;
}
</style>
<script>
import Api from "@/plugins/axios.js";
import html2canvas from "html2canvas";
import { Loading } from "element-ui";

export default {
  data() {
    return {
      uuid: null,
      agentType: null,
      type: null,
      info: null // 要显示的信息
    };
  },
  async mounted() {
    if (this.$route.query.uuid) {
      this.uuid = this.$route.query.uuid;
    }
    if (this.$route.query.agentType) {
      this.agentType = this.$route.query.agentType;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    await this.init();
    const loadingInstance = Loading.service({ fullscreen: true });
    setTimeout(() => {
      loadingInstance.close();
      setTimeout(() => {
        if (this.type === "down") {
          this.photo();
        } else if (this.type === "print") {
          this.print();
        }
      }, 1000);
    }, 5000);
    // this.photo();
    // this.print();
  },
  methods: {
    async init() {
      this.info = await Api.suppercode(
        this.$store.state.token,
        this.uuid,
        this.agentType
      );
    },
    // 截图
    photo() {
      html2canvas(this.$refs.scan).then(canvas => {
        canvas.toBlob(function(blob) {
          const a = document.createElement("a");
          const url = URL.createObjectURL(blob, "image/png", 1);
          const filename = "证书";
          a.href = url;
          a.download = filename;
          a.click();
        });
      });
    },
    // 打印
    print() {
      window.print();
    }
  }
};
</script>
